import { useReducer } from 'react';
import { SingleToolsBootstrap } from '@quicktools/shared-components';
import { HelmetProvider } from 'react-helmet-async';

import { Store, reducer, initialState } from '../../store';
import Header from '../../sections/Header';
import Main from '../../sections/Main';
import Landing from '../../sections/Landing';

import useStyles from './styles';

function App() {
  useStyles();
  const [state, dispatch] = useReducer(reducer, initialState);

  return (
    <HelmetProvider>
      <Store.Provider value={{ state, dispatch }}>
        <SingleToolsBootstrap>
          <Header />
          <Main />
          <Landing />
        </SingleToolsBootstrap>
      </Store.Provider>
    </HelmetProvider>
  );
}

export default App;
